/** "Removed in PF" / "New in PF" tags (UserFlows C-04). */
export function PfTags({ removed, isNew }: { removed: boolean; isNew: boolean }) {
  return (
    <>
      {removed && (
        <span className="tag tag-red" title="Not found in PF at the last refresh">
          Removed in PF
        </span>
      )}
      {isNew && <span className="tag tag-blue">New in PF</span>}
    </>
  )
}
